import { PageBlockColorV2, PageBlockImageReference, } from "./documentation-block-v2";
import { DocumentationItemHeaderAlignment, DocumentationItemHeaderAlignmentSchema, DocumentationItemHeaderImageScaleType, DocumentationItemHeaderImageScaleTypeSchema, } from "./item-header";
import { z } from "zod";
//
// Definitions
//
export const DocumentationItemHeaderV2 = z.object({
    description: z.string(),
    alignment: DocumentationItemHeaderAlignmentSchema,
    foregroundColor: PageBlockColorV2.nullish(),
    backgroundColor: PageBlockColorV2.nullish(),
    backgroundImageAsset: PageBlockImageReference.nullish(),
    backgroundImageScaleType: DocumentationItemHeaderImageScaleTypeSchema,
    showBackgroundOverlay: z.boolean(),
    showCoverText: z.boolean(),
    minHeight: z.number().nullish(),
});
export const defaultDocumentationItemHeaderV2 = {
    alignment: DocumentationItemHeaderAlignment.Left,
    backgroundImageScaleType: DocumentationItemHeaderImageScaleType.AspectFill,
    description: "",
    showBackgroundOverlay: false,
    showCoverText: true,
};
